export default {
  // Settings
  "settings": "Configurações",
  "profile": "Perfil",
  "security": "Segurança",
  "theme": "Tema",
  "feedback": "Feedback",
  "data": "Dados",
  "appearance_settings": "Configurações de Aparência",
  "select_theme": "Selecione seu tema preferido",
  "light": "Claro",
  "dark": "Escuro",
  "system": "Sistema",
  "language_changed": "Idioma alterado para",
  "failed_update_language": "Falha ao atualizar o idioma",
  "profile_settings": "Configurações de perfil",
  "username_cannot_change": "Você não pode alterar seu nome de usuário por",
  "more_days": "dias adicionais",
  "email_cannot_change": "O e-mail não pode ser alterado",
  "profile_links": "Links de perfil",
  "link_one": "Link 1",
  "link_two": "Link 2",
  "password_change": "Alterar senha",
  "current_password": "Senha atual",
  "new_password": "Nova senha",
  "confirm_password": "Confirmar senha",
  "update_password": "Atualizar senha",
  "password_must_be": "A senha deve ter entre 8 e 25 caracteres",
  "security_questions": "Perguntas de segurança",
  "security_question": "Pergunta de segurança",
  "update_security_questions": "Atualizar perguntas de segurança",
  "setup_security_questions": "Configurar perguntas de segurança",
  "select_question": "Selecionar pergunta",
  "your_answer": "Sua resposta",
  "enter_your_answer": "Digite sua resposta",
  "submit_feedback": "Enviar feedback",
  "feedback_type": "Tipo de feedback",
  "general_feedback": "Feedback geral",
  "bug_report": "Relatório de bug",
  "feature_request": "Solicitação de recurso",
  "airport_request": "Solicitar novo aeroporto",
  "airport_iata": "Código IATA do aeroporto",
  "airport_name": "Nome do aeroporto",
  "airport_location": "Localização do aeroporto",
  "your_feedback": "Seu feedback",
  "data_management": "Gerenciamento de dados",
  "delete_all_films": "Excluir todos os filmes",
  "delete_films_warning": "Isso excluirá permanentemente todos os filmes do seu inventário. Esta ação não pode ser desfeita.",
  "delete_all_reviews": "Excluir todas as avaliações",
  "delete_reviews_warning": "Isso excluirá permanentemente todas as suas avaliações. Esta ação não pode ser desfeita.",
  "delete_account": "Excluir conta",
  "delete_account_warning": "Aviso: Esta ação não pode ser desfeita. Isso excluirá permanentemente sua conta e removerá todos os seus dados de nossos servidores.",
  "account_deleted_success": "Sua conta foi excluída com sucesso",
  "account_deletion_failed": "Falha ao excluir conta",
  "reviews_deleted_success": "Todas as suas avaliações foram excluídas com sucesso",
  "reviews_deletion_failed": "Falha ao excluir avaliações",
  "films_deleted_success": "Todos os seus filmes foram excluídos com sucesso",
  "films_deletion_failed": "Falha ao excluir filmes",
  "confirm_delete_films": "Tem certeza de que deseja excluir todos os seus filmes? Esta ação não pode ser desfeita.",
  "confirm_delete_reviews": "Tem certeza de que deseja excluir todas as suas avaliações? Esta ação não pode ser desfeita.",
  "confirm_delete_account": "Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.",
  "create_username": "Criar nome de usuário",
  "username_required_description": "Por favor, crie um nome de usuário para sua conta. Os nomes de usuário devem ser únicos e podem conter letras, números e sublinhados.",
  "username": "Nome de usuário",
  "username_placeholder": "Digite um nome de usuário",
  "username_requirements": "O nome de usuário deve ter entre 4 e 25 caracteres e só pode conter letras, números e sublinhados.",
  "save_username": "Salvar nome de usuário",
  "username_taken": "Este nome de usuário já está em uso",
  "username_set_success": "Nome de usuário definido com sucesso",
  "username_set_error": "Falha ao definir nome de usuário"
};
